// ModalContext.tsx
'use client'
import React, { createContext, useState } from 'react'

interface ModalContextType {
  modals: Record<string, boolean>
  openModal: (modalId: string) => void
  closeModal: (modalId: string) => void
}

export const ModalContext = createContext<ModalContextType | undefined>(undefined)

export const ModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [modals, setModals] = useState<Record<string, boolean>>({})

  const openModal = (modalId: string) => setModals((prev) => ({ ...prev, [modalId]: true }))
  const closeModal = (modalId: string) => setModals((prev) => ({ ...prev, [modalId]: false }))

  return (
    <ModalContext.Provider value={{ modals, openModal, closeModal }}>
      {children}
    </ModalContext.Provider>
  )
}
